module.exports = {
      id: "messenger-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#messenger",
      toString: function () {
        return this.url;
      }
    }